import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import classNames from 'classnames';
import * as validators from '../../util/validators';
import {
  Form,
  PrimaryButton,
  FieldTextInput,
  NamedRedirect,
  FieldPhoneNumberInputWithDialCode,
  FieldCustomSelect,
  FieldAddress,
  FieldRadioButtonGroup,
  FieldRecaptcha,
  Modal,
  InlineTextButton,
  FieldNumberInput,
  SecondaryButton,
  FieldPerferredLang,
} from '../../components';

import css from './ConfirmSignupForm.module.css';
import { storedData } from '../../util/sessionStorageHelper';
import {
  USER_TYPE,
  customIdsKeyName,
  listingTypes,
  sosAdOptions,
} from '../../marketplace-custom-config';
import { FormSpy } from 'react-final-form';
import { replaceNumberWithCharacter } from '../../util/richText';
import { apiBaseUrl } from '../../util/api';
import axios from '../../util/axiosHelper';
import { isEmpty } from 'lodash';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { getDefaultTimeZoneOnBrowser } from '../../util/dates';

const textfield = 'textfield';
const errorTextField = 'errorTextField';

class ProviderConfirmSignupComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOtpModal: false,
      signStep: 0,
      otpValidationInProgress: false,
    };
  }

  handleFormSubmit = event => {
    event.preventDefault();
    event.stopPropagation();
    const { onSubmit, formApi } = this.props;
    const { values } = formApi.getState();
    const { isPhoneNumberVerified } = values;
    if (!isPhoneNumberVerified) {
      if (this.state.showOtpModal) {
        this.verifyOtp();
      } else {
        this.requestForOtp();
      }
    } else {
      const {
        firstName,
        lastName,
        phoneNumber,
        company,
        jobTitle,
        businessAddress,
        adNewsSource,
        industryType,
        preferredLang,
      } = values;

      const { number, iso2, iso3, dialCode } = phoneNumber;
      const publicData = {
        companyName: company,
        companyAddress: businessAddress,
        adNewsSource,
        industryType: industryType.value,
        isProvider: true,
        preferredLang,
      };
      const protectedData = {
        jobTitle,
        phoneNumber: { number, iso2, iso3, dialCode },
        isPhoneNumberVerified,
        isSocialSignup: true,
        timeZone: getDefaultTimeZoneOnBrowser(),
      };
      const updatedValues = { firstName, lastName, publicData, protectedData };
      onSubmit(updatedValues);
    }
  };

  handleRecaptchStatusChange = value => {
    const { recaptchaStatus } = value;
    const { formApi } = this.props;
    formApi.change('recaptchaStatus', { ...recaptchaStatus });
  };

  setShowOtpModal = status => {
    this.setState({ showOtpModal: status });
  };

  checkAndHideOtpModal = () => {
    if (this.state.otpValidationInProgress) return;
    this.setShowOtpModal(false);
  };

  formBatchUpdate = (entries = []) => {
    const { formApi } = this.props;
    formApi.batch(() => {
      for (let entry of entries) {
        formApi.change(entry[0], entry[1]);
      }
    });
  };

  formBatchAndDelayUpdate = (data, hasDelayUpdate = false, delayTimeout = 100) => {
    if (typeof data !== 'object' && data.constructor !== Object) return;
    const { batchUpdateData = {}, delayUpdateData = {} } = data;
    let entries = Object.entries(batchUpdateData);
    this.formBatchUpdate(entries);
    if (hasDelayUpdate && !isEmpty(delayUpdateData)) {
      entries = Object.entries(delayUpdateData);
      setTimeout(() => this.formBatchUpdate(entries), delayTimeout);
    }
  };

  requestForOtp = async () => {
    this.setShowOtpModal(true);
    try {
      const { formApi } = this.props;
      const { values } = formApi.getState();
      const {
        phoneNumber: { number, dialCode },
      } = values;
      const mobileNumber = `${dialCode}${number}`;
      const url = `${apiBaseUrl()}/api/user/generate/phoneotp/mobile`;
      await axios.post(url, { mobile: mobileNumber });
    } catch (err) {
      console.error(err);
    }
  };
  verifyOtp = async () => {
    if (this.state.otpValidationInProgress) return;
    this.setState({ otpValidationInProgress: true });
    const { formApi } = this.props;
    const { values } = formApi.getState();
    const {
      phoneNumber: { number, dialCode },
      otp,
    } = values;
    formApi.change('refOtp', '');
    try {
      const mobileNumber = `${dialCode}${number}`;
      const url = `${apiBaseUrl()}/api/user/validate/phoneotp/mobile`;
      await axios.post(url, { mobile: mobileNumber, otp });
      formApi.change('isPhoneNumberVerified', true);
      this.setState({ showOtpModal: false, otpValidationInProgress: false });
    } catch (err) {
      console.error(err);
      const data = { batchUpdateData: { refOtp: '-1', otp: `${otp} ` }, delayUpdateData: { otp } };
      this.formBatchAndDelayUpdate(data, true);
      this.setState({ otpValidationInProgress: false });
    }
  };

  handleFormSpyChange = formValues => {
    const { formApi } = this.props;
    const { values, active } = formValues;
    const { refOtp } = values;
    if (active && active.toLowerCase() === 'otp' && !isNaN(parseInt(refOtp))) {
      formApi.change('refOtp', '');
    }
  };

  handleOnCancelBtnClick = e => {
    const { history } = this.props;
    history.replace(createResourceLocatorString('LandingPage', routeConfiguration()));
  };

  render() {
    const {
      intl,
      formId,
      onOpenTermsOfService,
      authInfo,
      idp,
      inProgress,
      invalid,
      rootClassName,
      className,
      values,
      onManageDisableScrolling,
      userNativeLang,
      errorMessage,
    } = this.props;
    const { refOtp = '', phoneNumber, recaptchaStatus = {} } = values || {};
    const { hasRecaptchaValidated = false } = recaptchaStatus;
    const { dialCode, number = '' } = phoneNumber;
    const phoneNumberWithDialCode = `${dialCode} ${replaceNumberWithCharacter(number, 'X')}`;
    const { userType, firstName, lastName } = authInfo || {};
    const sessionUserType = storedData(USER_TYPE);
    const isValidUserType =
      !!userType &&
      !!sessionUserType &&
      sessionUserType === userType &&
      [customIdsKeyName.business, customIdsKeyName.guest].includes(sessionUserType);

    if (!isValidUserType) {
      return <NamedRedirect name="SignupAsCompanyPage" />;
    }
    const preferredLangId = formId ? `${formId}.preferredLang` : 'preferredLang';

    // firstName
    const firstNameLabel = intl.formatMessage({
      id: 'SignupForm.firstNameLabel',
    });
    const firstNamePlaceholder = intl.formatMessage({
      id: 'SignupForm.firstNamePlaceholder',
    });
    const firstNameRequiredMessage = intl.formatMessage({
      id: 'SignupForm.firstNameRequired',
    });
    const firstNameRequired = validators.required(firstNameRequiredMessage);

    // lastName
    const lastNameLabel = intl.formatMessage({
      id: 'SignupForm.lastNameLabel',
    });
    const lastNamePlaceholder = intl.formatMessage({
      id: 'SignupForm.lastNamePlaceholder',
    });
    const lastNameRequiredMessage = intl.formatMessage({
      id: 'SignupForm.lastNameRequired',
    });
    const lastNameRequired = validators.required(lastNameRequiredMessage);

    // company
    const companyLabel = intl.formatMessage({
      id: 'SignupForm.companyLabel',
    });
    const companyPlaceholder = intl.formatMessage({
      id: 'SignupForm.companyPlaceholder',
    });
    const companyRequiredMessage = intl.formatMessage({
      id: 'SignupForm.companyRequired',
    });
    const companyRequired = validators.required(companyRequiredMessage);

    // job title
    const jobTitleLabel = intl.formatMessage({
      id: 'SignupForm.jobTitleLabel',
    });
    const jobTitlePlaceholder = intl.formatMessage({
      id: 'SignupForm.jobTitlePlaceholder',
    });
    const jobTitleRequiredMessage = intl.formatMessage({
      id: 'SignupForm.jobTitleRequired',
    });
    const jobTitleRequired = validators.required(jobTitleRequiredMessage);

    //otp
    const otpPlaceholder = intl.formatMessage({
      id: 'SignupForm.otpPlaceholder',
    });
    const otpRequiredMessage = intl.formatMessage({
      id: 'SignupForm.otpRequired',
    });
    const otpInvalidMessage = intl.formatMessage({
      id: 'SignupForm.invalidOtp',
    });

    const otpValidator = validators.composeValidators(
      validators.required(otpRequiredMessage),
      validators.isValidOtp(otpInvalidMessage, refOtp)
    );

    //advertising source
    const adNewsSourceLabel = intl.formatMessage({ id: 'SignupForm.adNewsSource' });
    const sourcesOptions = sosAdOptions.map(option => ({
      key: option.value,
      label: option.label[userNativeLang],
    }));

    // phone number
    const phoneNumberLabel = intl.formatMessage({
      id: 'SignupForm.phoneNumbeLabel',
    });
    const phoneNumberPlaceholder = intl.formatMessage({
      id: 'SignupForm.phoneNumbePlaceholder',
    });
    const phoneNumberRequiredMessage = intl.formatMessage({
      id: 'SignupForm.phoneNumbeRequired',
    });
    const phoneNumberRequired = validators.phoneNumberRequired(phoneNumberRequiredMessage);

    // industry Type
    const industryTypeLabel = intl.formatMessage({
      id: 'SignupForm.industryTypeLabel',
    });
    const industryTypePlaceholder = intl.formatMessage({
      id: 'SignupForm.industryTypePlaceholder',
    });
    const industryTypeRequiredMessage = intl.formatMessage({
      id: 'SignupForm.industryTypeRequired',
    });
    const industryTypeRequired = validators.required(industryTypeRequiredMessage);

    // business address
    const addressLabel = intl.formatMessage({
      id: 'SignupForm.adrressLabel',
    });
    const addressPlaceholder = intl.formatMessage({
      id: 'SignupForm.adrressPlaceholder',
    });
    const postalLabel = intl.formatMessage({
      id: 'SignupForm.postalLabel',
    });
    const postalPlaceholder = intl.formatMessage({
      id: 'SignupForm.postalPlaceholder',
    });
    const addressRequiredMessage = intl.formatMessage({
      id: 'SignupForm.adrressRequired',
    });
    const addressRequired = validators.addressRequired(addressRequiredMessage);

    const classes = classNames(rootClassName || css.root, className);
    const submitInProgress = inProgress;
    const submitDisabled = invalid || submitInProgress || !hasRecaptchaValidated;

    const handleTermsKeyUp = e => {
      // Allow click action with keyboard like with normal links
      if (e.keyCode === KEY_CODE_ENTER) {
        onOpenTermsOfService();
      }
    };
    const termsLink = (
      <span
        className={css.termsLink}
        onClick={onOpenTermsOfService}
        role="button"
        tabIndex="0"
        onKeyUp={handleTermsKeyUp}
      >
        <FormattedMessage id="ConfirmSignupForm.termsAndConditionsLinkText" />
      </span>
    );

    // If authInfo is not available we should not show the ConfirmForm
    if (!authInfo) {
      return null;
    }

    return (
      <Form className={classes} onSubmit={this.handleFormSubmit}>
        <FormSpy
          subscription={{ values: true, active: true }}
          onChange={this.handleFormSpyChange}
        />
        <div>
          <div className={css.row}>
            <FieldTextInput
              className={textfield}
              errorClassName={errorTextField}
              type="text"
              id={formId ? `${formId}.firstName` : 'firstName'}
              name="firstName"
              autoComplete="given-name"
              label={firstNameLabel}
              placeholder={firstNamePlaceholder}
              initialValue={firstName}
              validate={firstNameRequired}
            />
            <FieldTextInput
              className={textfield}
              errorClassName={errorTextField}
              type="text"
              id={formId ? `${formId}.lastName` : 'lastName'}
              name="lastName"
              autoComplete="family-name"
              label={lastNameLabel}
              placeholder={lastNamePlaceholder}
              initialValue={lastName}
              validate={lastNameRequired}
            />
          </div>
          <div className={css.row}>
            <FieldTextInput
              className={textfield}
              errorClassName={errorTextField}
              type="text"
              name="jobTitle"
              id={formId ? `${formId}.jobTitle` : 'jobTitle'}
              label={jobTitleLabel}
              placeholder={jobTitlePlaceholder}
              // validate={jobTitleRequired}
            />

            <FieldPhoneNumberInputWithDialCode
              name="phoneNumber"
              id={formId ? `${formId}.phoneNumber` : 'phoneNumber'}
              label={phoneNumberLabel}
              placeholder={phoneNumberPlaceholder}
              validate={phoneNumberRequired}
              className={textfield}
              errorClassName={errorTextField}
            />
          </div>
          <div className={css.row}>
            <FieldTextInput
              className={textfield}
              errorClassName={errorTextField}
              type="text"
              id={formId ? `${formId}.company` : 'company'}
              name="company"
              autoComplete="company"
              label={companyLabel}
              placeholder={companyPlaceholder}
              validate={companyRequired}
            />
            <FieldCustomSelect
              userNativeLang={userNativeLang}
              options={Object.values(listingTypes)}
              id={formId ? `${formId}.industryType` : 'industryType'}
              name="industryType"
              label={industryTypeLabel}
              placeholder={industryTypePlaceholder}
              validate={industryTypeRequired}
              className={textfield}
              errorClassName={errorTextField}
              isSearchable={true}
            />
          </div>
          <FieldAddress
            id={formId ? `${formId}.businessAddress` : 'businessAddress'}
            name="businessAddress"
            addressLabel={addressLabel}
            addressPlaceholder={addressPlaceholder}
            postalLabel={postalLabel}
            postalPlaceholder={postalPlaceholder}
            className={textfield}
            errorClassName={errorTextField}
            validate={addressRequired}
            userNativeLang={userNativeLang}
          />
          <div>
            <FieldPerferredLang
              id={preferredLangId}
              userNativeLang={userNativeLang}
              name="preferredLang"
              className={textfield}
              errorClassName={errorTextField}
            />
          </div>
          <FieldRadioButtonGroup
            label={adNewsSourceLabel}
            name="adNewsSource"
            id={formId ? `${formId}.adNewsSource` : 'adNewsSource'}
            options={sourcesOptions}
            className={css.radioBtnGrp}
          />

          <FieldRecaptcha
            id={formId ? `${formId}.recaptchaStatus` : 'recaptchaStatus'}
            name="recaptchaStatus"
            enableRecaptcha={!invalid}
            onChange={this.handleRecaptchStatusChange}
          />
        </div>
        <div className={css.bottomWrapper}>
          {errorMessage}
          <div className={css.btnWrapper}>
            <PrimaryButton
              type="submit"
              inProgress={submitInProgress}
              disabled={submitDisabled}
              className={css.submitBtn}
            >
              <FormattedMessage id="SignupForm.signUp" />
            </PrimaryButton>
            <InlineTextButton
              type="button"
              className={css.cancelBtn}
              onClick={this.handleOnCancelBtnClick}
            >
              <FormattedMessage id="SignupForm.signUpCancel" />
            </InlineTextButton>
          </div>
          {/*className={css.bottomWrapperText}*/}
          {/*<p>
            <span className={css.termsText}>
              <FormattedMessage
                id="SignupForm.termsAndConditionsAcceptText"
                values={{ termsLink }}
              />
            </span>
    </p>*/}
        </div>

        {/*<div className={css.bottomWrapper}>
          <p className={css.bottomWrapperText}>
            <span className={css.termsText}>
              <FormattedMessage
                id="ConfirmSignupForm.termsAndConditionsAcceptText"
                values={{ termsLink }}
              />
            </span>
          </p>
          <PrimaryButton type="submit" inProgress={submitInProgress} disabled={submitDisabled}>
            <FormattedMessage id="ConfirmSignupForm.signUp" values={{ idp: idp }} />
          </PrimaryButton>
    </div>*/}

        <Modal
          id="ProviderSignup.verifyotp"
          isOpen={this.state.showOtpModal}
          onClose={this.checkAndHideOtpModal}
          onManageDisableScrolling={onManageDisableScrolling}
          showCloseButtonMessage={false}
        >
          {this.state.showOtpModal && (
            <div className={css.otpContentWrapper}>
              <div className={css.contentHeading}>
                <h3 className={css.heading}>
                  {intl.formatMessage({ id: 'SignupForm.otpHeading' })}
                </h3>
                <p className={css.subHeading}>
                  {intl.formatMessage({ id: 'SignupForm.otpSubheading' })}
                </p>
                <div>
                  <div className={css.changeNumberWrapper}>
                    <span className={css.changeNumberText}>{phoneNumberWithDialCode}</span>
                    <InlineTextButton
                      type="button"
                      className={css.changeNumberBtn}
                      onClick={this.checkAndHideOtpModal}
                    >
                      {intl.formatMessage({ id: 'SignupForm.changeNumberText' })}
                    </InlineTextButton>
                  </div>
                  <FieldNumberInput
                    id="otp"
                    name="otp"
                    placeholder={otpPlaceholder}
                    validate={otpValidator}
                    className={textfield}
                    errorClassName={errorTextField}
                  />
                  <div className={css.noOtpWrapper}>
                    <span className={css.noOtpText}>
                      {intl.formatMessage({ id: 'SignupForm.noOtpText' })}
                    </span>
                    <InlineTextButton
                      type="button"
                      className={css.noOtpBtn}
                      onClick={this.requestForOtp}
                    >
                      {intl.formatMessage({ id: 'SignupForm.resendOtpText' })}
                    </InlineTextButton>
                  </div>
                </div>
                <SecondaryButton
                  type="button"
                  className={css.otpCheckBtn}
                  inProgress={this.state.otpValidationInProgress}
                  onClick={this.verifyOtp}
                >
                  {intl.formatMessage({ id: 'SignupForm.otpHeading' })}
                </SecondaryButton>
              </div>
            </div>
          )}
        </Modal>
      </Form>
    );
  }
}

ProviderConfirmSignupComponent.defaultProps = { inProgress: false };

const { bool, func } = PropTypes;

ProviderConfirmSignupComponent.propTypes = {
  inProgress: bool,
  onOpenTermsOfService: func.isRequired,
  // from injectIntl
  intl: intlShape.isRequired,
};
const ProviderConfirmSignup = compose(injectIntl)(ProviderConfirmSignupComponent);
export default ProviderConfirmSignup;
